import React, { useState, memo } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: 'Yo gano poco, no puedo ahorrar.',
    a: 'Esto no empieza por ahorrar. Empieza por dejar de sangrar. Cuando tapas la fuga, el dinero empieza a aparecer solo.'
  }, {
    q: 'Me desordeno cuando me estreso.',
    a: 'Por eso el método tiene dos paredes y un corte semanal. No depende de tu ánimo ni de tu memoria. El sistema te sostiene cuando tú no puedes.'
  }, {
    q: 'Mi familia no entiende y me pide plata.',
    a: "No necesitas permiso para ordenarte. Necesitas un límite que se cumpla. La guía incluye guiones exactos para decir 'no' sin pelear."
  }, {
    q: '¿Es una app o un curso?',
    a: 'Es una guía digital (PDF) directa al grano con plantillas imprimibles. No tienes que instalar nada ni ver horas de video. Lo lees y lo aplicas.'
  }];
  return <section className="py-10 px-4 bg-stone-50" data-id="element-40">
      <div className="max-w-2xl mx-auto" data-id="element-41">
        <h2 className="text-2xl font-bold text-[#1e3a5f] mb-6 text-center" data-id="element-42">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-3" data-id="element-43">
          {faqs.map((faq, idx) => <FAQItem key={idx} question={faq.q} answer={faq.a} data-id="element-44" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white rounded-xl shadow-sm border border-stone-200 overflow-hidden" data-id="element-45">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-4 py-3 text-left flex justify-between items-center focus:outline-none" data-id="element-46">
        <span className="font-bold text-[#1e3a5f] text-base" data-id="element-47">{question}</span>
        {isOpen ? <ChevronUp className="text-slate-400 h-4 w-4" data-id="element-48" /> : <ChevronDown className="text-slate-400 h-4 w-4" data-id="element-49" />}
      </button>

      <div className={`px-4 transition-all duration-300 ease-in-out ${isOpen ? 'max-h-32 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-50">
        <p className="text-slate-600 text-sm" data-id="element-51">{answer}</p>
      </div>
    </div>;
}